"use strict";

exports.__esModule = true;
exports.StyledDrawer = exports.ScrollArea = exports.DrawerTitle = exports.DrawerSpacer = exports.DrawerHeader = exports.DrawerContent = exports.DrawerButton = exports.ArrowIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../../buttons/Button/Button"));

var _ScrollArea = _interopRequireDefault(require("./ScrollArea/ScrollArea"));

var _ArrowUpIcon = _interopRequireDefault(require("../../icons/standard-icons/ArrowUpIcon"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const getBorderOffset = (value, multiplier = 1) => {
  if (typeof value === 'number') {
    return `${value * multiplier}px`;
  } else {
    const [dimension, unit] = (0, _polished.getValueAndUnit)(value);
    return `${dimension * multiplier}${unit || 'px'}`;
  }
};

const DrawerSpacer = _styledComponents.default.div`
    height: 50px;
`;
exports.DrawerSpacer = DrawerSpacer;
const DrawerHeader = _styledComponents.default.div`
    position: relative;
    margin: 0;
    text-align: left;
    padding: 0 calc(${({
  theme
}) => theme.space[5]} + ${props => getBorderOffset(props.parentBorderOffset)});
    font-size: ${({
  theme
}) => theme.fontSizes[2]};
`;
exports.DrawerHeader = DrawerHeader;
const DrawerTitle = _styledComponents.default.h3`
    margin: 0;
    line-height: 50px;
`;
exports.DrawerTitle = DrawerTitle;
const DrawerButton = (0, _styledComponents.default)(_Button.default)`
    position: absolute;
    top: 13px;
    right: 13px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    min-height: initial;
    padding: 0;

    span {
        position: absolute;
        top: -1px;
        left: 0px;
        width: 20px;
        font-size: 17px;
        text-align: center;
    }
`;
exports.DrawerButton = DrawerButton;
const ArrowIcon = (0, _styledComponents.default)(_ArrowUpIcon.default)`
    display: block;
    margin: 2px auto;
    width: 12px;
    height: auto;
    transition: transform 250ms ease-in-out;
`;
exports.ArrowIcon = ArrowIcon;
const DrawerContent = _styledComponents.default.div`
    margin: 0;
    text-align: left;
    padding: 0;
    padding-top: 0;
    height: calc(100% - 50px);
`;
exports.DrawerContent = DrawerContent;
const StyledDrawer = _styledComponents.default.div`

    ${props => (0, _styledComponents.css)`
        position: absolute;
        top: calc(100% - 50px + ${getBorderOffset(props.parentBorderOffset)});
        left: -${getBorderOffset(props.parentBorderOffset)};
        right: -${getBorderOffset(props.parentBorderOffset)};
        display: block;
        height: 50px;
        color: ${({
  theme
}) => theme.colors.drawer.text};
        background-color: ${({
  theme
}) => theme.colors.drawer.background};
        overflow: hidden;
        transition: all 250ms ease-in-out;
    `}

    ${props => props.open && (0, _styledComponents.css)`
        height: calc(100% + ${getBorderOffset(props.parentBorderOffset, 2)});
        top: -${getBorderOffset(props.parentBorderOffset)};

        ${ArrowIcon} {
            transform: rotate(180deg);
        }
    `}

    ${props => props.position === 'top' && (0, _styledComponents.css)`
        top: -${getBorderOffset(props.parentBorderOffset)};

        ${ArrowIcon} {
            transform: rotate(180deg);
        }
    `}

    ${props => props.position === 'top' && props.open && (0, _styledComponents.css)`
        top: -${getBorderOffset(props.parentBorderOffset)};
        height: calc(100% + ${getBorderOffset(props.parentBorderOffset, 2)});

        ${ArrowIcon} {
            transform: rotate(0deg);
        }
    `}

    ${props => props.contrast && (0, _styledComponents.css)`
        color: ${({
  theme
}) => theme.colors.drawer.contrast.text};
        background-color: ${({
  theme
}) => theme.colors.drawer.contrast.background};
    `}

    
`;
exports.StyledDrawer = StyledDrawer;
const StyledScrollArea = (0, _styledComponents.default)(_ScrollArea.default)`
    max-height: 100%;
    padding: 0 calc(${({
  theme
}) => theme.space[5]});
`;
exports.ScrollArea = StyledScrollArea;